if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.submitButtonText =
          this.submitButton?.querySelector('span');

        this.hideErrors =
          this.dataset.hideErrors === 'true';

        this.error = false;

        if (
          !this.form ||
          !this.variantIdInput ||
          !this.submitButton
        ) {
          return;
        }

        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        if (this.cart) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          !this.form ||
          !this.submitButton ||
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();
        this.error = false;

        this.submitButton.setAttribute(
          'aria-disabled',
          'true'
        );

        this.submitButton.classList.add('loading');

        const spinner =
          this.querySelector('.loading__spinner');

        spinner?.classList.remove('hidden');

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const sectionsToRender =
          this.cart &&
          typeof this.cart.getSectionsToRender ===
            'function'
            ? this.cart.getSectionsToRender()
            : [{ id: 'cart-icon-bubble' }];

        formData.delete('sections');
        formData.delete('sections_url');

        formData.append(
          'sections',
          sectionsToRender
            .map((section) => section.id)
            .join(',')
        );

        formData.append(
          'sections_url',
          window.location.pathname
        );

        if (
          this.cart &&
          typeof this.cart.setActiveElement ===
            'function'
        ) {
          this.cart.setActiveElement(
            document.activeElement
          );
        }

        config.body = formData;

        try {
          const fetchResponse = await fetch(
            `${routes.cart_add_url}`,
            config
          );

          const response =
            await fetchResponse.json();

          if (
            !fetchResponse.ok ||
            response.status
          ) {
            this.error = true;

            try {
              const publishResult = publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source: 'product-form',
                  productVariantId:
                    formData.get('id'),
                  errors:
                    response.errors ||
                    response.description,
                  message: response.message,
                }
              );

              if (
                publishResult &&
                typeof publishResult.catch ===
                  'function'
              ) {
                publishResult.catch(
                  (publishError) => {
                    console.warn(
                      'Cart error event could not be published.',
                      publishError
                    );
                  }
                );
              }
            } catch (publishError) {
              console.warn(
                'Cart error event could not be published.',
                publishError
              );
            }

            this.handleErrorMessage(
              response.description ||
                response.message ||
                'The product could not be added.'
            );

            const soldOutMessage =
              this.submitButton.querySelector(
                '.sold-out-message'
              );

            if (soldOutMessage) {
              this.submitButton.setAttribute(
                'aria-disabled',
                'true'
              );

              this.submitButtonText?.classList.add(
                'hidden'
              );

              soldOutMessage.classList.remove(
                'hidden'
              );
            }

            return;
          }

          try {
            sessionStorage.setItem(
              'great-town-cart-updated',
              String(Date.now())
            );
          } catch (storageError) {
            /* Session storage is optional. */
          }

          try {
            const publishResult = publish(
              PUB_SUB_EVENTS.cartUpdate,
              {
                source: 'product-form',
                productVariantId:
                  formData.get('id'),
                cartData: response,
              }
            );

            if (
              publishResult &&
              typeof publishResult.catch ===
                'function'
            ) {
              publishResult.catch(
                (publishError) => {
                  console.warn(
                    'Cart update event could not be published.',
                    publishError
                  );
                }
              );
            }
          } catch (publishError) {
            console.warn(
              'Cart update event could not be published.',
              publishError
            );
          }

          const renderCart = () => {
            if (
              this.cart &&
              typeof this.cart.renderContents ===
                'function'
            ) {
              try {
                this.cart.renderContents(response);
                return;
              } catch (renderError) {
                console.warn(
                  'Cart notification could not be rendered.',
                  renderError
                );
              }
            }

            this.updateCartBubble(response);
            this.showInlineConfirmation();
          };

          const quickAddModal =
            this.closest('quick-add-modal');

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                window.setTimeout(
                  renderCart,
                  0
                );
              },
              { once: true }
            );

            quickAddModal.hide(true);
          } else {
            renderCart();
          }
        } catch (error) {
          this.error = true;

          console.error(
            'The product could not be added to the cart.',
            error
          );

          this.handleErrorMessage(
            'The product could not be added. Please try again.'
          );
        } finally {
          this.submitButton.classList.remove(
            'loading'
          );

          if (
            this.cart?.classList.contains(
              'is-empty'
            )
          ) {
            this.cart.classList.remove(
              'is-empty'
            );
          }

          if (!this.error) {
            this.submitButton.removeAttribute(
              'aria-disabled'
            );
          }

          spinner?.classList.add('hidden');
        }
      }

      updateCartBubble(response) {
        try {
          const sectionHtml =
            response.sections?.[
              'cart-icon-bubble'
            ];

          const currentBubble =
            document.getElementById(
              'cart-icon-bubble'
            );

          if (
            !sectionHtml ||
            !currentBubble
          ) {
            return;
          }

          const parsedDocument =
            new DOMParser().parseFromString(
              sectionHtml,
              'text/html'
            );

          const updatedBubble =
            parsedDocument.getElementById(
              'cart-icon-bubble'
            ) ||
            parsedDocument.querySelector(
              '.shopify-section'
            );

          if (updatedBubble) {
            currentBubble.innerHTML =
              updatedBubble.innerHTML;
          }
        } catch (bubbleError) {
          console.warn(
            'Cart counter could not be updated.',
            bubbleError
          );
        }
      }

      showInlineConfirmation() {
        if (!this.submitButtonText) return;

        const originalText =
          this.submitButtonText.textContent;

        this.submitButtonText.textContent =
          'Added to Selection';

        window.setTimeout(() => {
          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              originalText;
          }
        }, 1600);
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (
            text &&
            this.submitButtonText
          ) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form?.querySelector(
          '[name="id"]'
        );
      }
    }
  );
}